import PropTypes from 'prop-types';
// -*- mode: jsx;-*-

import TextField from './TextField.js';

const MAX_GIFT_CODES = 5; // Consider making this a component parameter

/**
 * Growable list of gift code inputs
 * @param giftCodes
 * @param handleGiftCodesChange
 * @param addGiftCodeCallback
 * @param removeGiftCodeCallback
 * @returns {JSX.Element}
 * @constructor
 */
export default function DynamicGiftCodeInputList({
    giftCodes, handleGiftCodesChange, addGiftCodeCallback, removeGiftCodeCallback,
}) {
    const giftCodeInputs = giftCodes.map((giftCode, index) => {
        return (
            <div key={`giftCodes[${index}]`}>
                <TextField name={`giftCodes[${index}]`} key={`giftCodes[${index}]`}
                    pattern="[A-Za-z]{4}[-]?[A-Za-z]{4}"
                    label={''}
                    value={giftCode}
                    inputChangeCallback={handleGiftCodesChange} />
                <button id={`giftCodesRemoveButton[${index}]`} className="link"
                    type='button' onClick={removeGiftCodeCallback}>Remove</button>
            </div>
        );
    });

    return (
        <div>
            <div className="giftcode-field">
                <label>Gift Code</label>
                {giftCodeInputs}
            </div>
            {
                giftCodes.length < MAX_GIFT_CODES &&
                    <button id="giftCodesAddButton" className="button-secondary small"
                        type='button' onClick={addGiftCodeCallback}>Add another gift code</button>
            }
        </div>
    );
}
DynamicGiftCodeInputList.propTypes = {
    giftCodes: PropTypes.array.isRequired,
    handleGiftCodesChange: PropTypes.func.isRequired,
    addGiftCodeCallback: PropTypes.func.isRequired,
    removeGiftCodeCallback: PropTypes.func.isRequired,
};
